import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@controladad/ng-base';
import { AuthEntity, LoginModel, UserEntity } from '@models';
import { BaseApi } from './_base-api';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseApi<any> {
  private readonly environment = inject(ENVIRONMENT);

  constructor() {
    super('');
  }

  login(model: LoginModel) {
    return this.environment.panel === 'admin'
      ? http$.post<AuthEntity>('/AdminPanel/AdminLoginWithEmailAndPassword', model)
      : http$.post<AuthEntity>('/App/VendorLoginWithEmailAndPassword', model);
  }

  me() {
    return http$.get<{ userDetails: UserEntity }>('/Me');
  }
}
